import { definePreset } from "@primeuix/themes";
import Lara from "@primeuix/themes/lara";

export const Kno2Lara = definePreset(Lara, {
    semantic: {
        extend: {
            fontFamily: "'Inter Variable', 'Inter', system-ui, sans-serif"
        }
    },
    components: {
        card: {
            title: {
                fontSize: "1.1rem"
            }
        },
        progressspinner: {
            colorScheme: {
                light: {
                    root: {
                        colorOne: "{primary.color}",
                        colorTwo: "{primary.color}",
                        colorThree: "{primary.color}",
                        colorFour: "{primary.color}"
                    }
                }
            }
        }
    }
});
